import React from "react";
import { Divider, Paper } from "convertupleads-theme";
import PageTitleBox from "../../../common/PageTitleBox";
import BasicTextField from "./BasicTextField/BasicTextField";
import TextFieldPlaceholder from "./BasicTextField/TextFieldPlaceholder";
import TextFieldWithValue from "./BasicTextField/TextFieldWithValue";
import TextFieldWithStartAdorn from "./BasicTextField/TextFieldWithStartAdorn";
import TextFieldWithStartAdornText from "./BasicTextField/TextFieldWithStartAdornText";
import TextFieldWithEndAdorn from "./BasicTextField/TextFieldWithEndAdorn";
import TextFieldSizes from "./BasicTextField/TextFieldSizes";
import TextFieldWithEndAdornText from "./BasicTextField/TextFieldWithEndAdornText";
import TextFieldColors from "./BasicTextField/TextFieldColors";
import BasicTextFieldError from "./BasicTextField/BasicTextFieldError";
import TextFieldWithComponents from "./BasicTextField/TextFieldWithComponents";
import TextFieldWithSelectPage from "./BasicTextField/TextFieldWithSelectPage";
import TextFieldWithCopy from "./BasicTextField/TextFieldWithCopy";

const TextFieldPage = () => {
  return (
    <>
      <Paper elevation={0}>
        <PageTitleBox
          title={"Text Field"}
          description={"Text Fields let users enter and edit text."}
        />
        <Divider light />
        <BasicTextField />
        <TextFieldSizes />
        <TextFieldColors />
        <TextFieldPlaceholder />
        <TextFieldWithValue />
        <TextFieldWithStartAdorn />
        <TextFieldWithSelectPage />
        <TextFieldWithCopy />
        <TextFieldWithEndAdorn />
        <TextFieldWithStartAdornText />
        <TextFieldWithEndAdornText />
        <BasicTextFieldError />
        <TextFieldWithComponents />
      </Paper>
    </>
  );
};

export default TextFieldPage;
